/**
 * L2-R5: moved verbatim from @shared/models/folders/helpers/folder-factory.
 * That host path is now a re-export shim of this file.
 */
import { ExpandableResource } from '../tree/expandable-resource';

export const makeNewFolderFactory = () => {
  return new ExpandableResource(
    { name: '', description: '', isDir: true, data: [] },
    { childKey: 'data', hasChildrenIndicator: 'isDir' }
  );
};

export const makeTransientFolder = () => {
  const tracientFolder: any = makeNewFolderFactory();
  ((tracientFolder.name = 'NONE'), (tracientFolder.id = -1));
  return tracientFolder;
};
